export const scheduleName = "ipm_ping_schedule";
export const intervalKey = "ipm_ping_interval";
export const serverUrlKey = "ipm_server_url";
export const lastPingKey = "ipm_last_ping";
export const pingCountPrefsKey = "ipm_ping_count";
